import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { useTranslation } from 'react-i18next';

ChartJS.register(ArcElement, Tooltip, Legend);

interface InvoiceStatusChartProps {
  data: {
    collected: number;
    received: number;
    pending: number;
  };
}

export const InvoiceStatusChart: React.FC<InvoiceStatusChartProps> = ({ data }) => {
  const { t } = useTranslation();

  const chartData = {
    labels: [
      t('status.collected'),
      t('status.received'),
      t('status.pending'),
    ],
    datasets: [
      {
        label: t('invoices:title'),
        data: [data.collected, data.received, data.pending],
        backgroundColor: [
          '#10b981',
          '#3b82f6',
          '#f59e0b',
        ],
        borderColor: [
          '#059669',
          '#1d4ed8',
          '#d97706',
        ],
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        position: 'bottom' as const,
      },
      tooltip: {
        callbacks: {
          label: function(context: any) {
            return context.label + ': ' + context.parsed;
          }
        }
      }
    },
  };

  return (
    <div className="chart-container">
      <h3>{t('dashboard:invoiceStatus')}</h3>
      <Pie data={chartData} options={options} />
    </div>
  );
};

